// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"a9378460","453":"8f0c5d79","583":"f864d5e8","952":"2ea7e33a"}[chunkId] + ".chunk.js";
};